import {
  EnvironmentConfig,
  ADConfig
} from '../environments/environment.models';

import { serviceRoutesContainer } from '../serviceroutes/serviceroutes'

var webUIResourceId: string = "469774cc-9f62-4757-b6e2-e1793e790869"
 
export const environment: EnvironmentConfig = {
  environmentName: 'prod',
  production: true, 
  hmr: false,
  config: {
      tenant: 'VillaPlusLtd.onmicrosoft.com',
      clientId: webUIResourceId,
      protectedResourceMap: createEndpointsConfig(),
      redirectUri: serviceRoutesContainer.production.projectWebBaseUrl,
      postLogoutRedirectUri: serviceRoutesContainer.production.projectWebBaseUrl,
      isAngular: true
  } as ADConfig,
  configIFrame: {
      tenant: 'VillaPlusLtd.onmicrosoft.com',
      clientId: webUIResourceId,
      protectedResourceMap: createEndpointsConfig(),
      redirectUri: serviceRoutesContainer.production.projectWebBaseUrl,
      isAngular: true
  } as ADConfig,
  services: serviceRoutesContainer.production,
} as EnvironmentConfig;

function createEndpointsConfig(): Map<string, Array<string>> {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(serviceRoutesContainer.production.microsoftGraphBaseUrl, ['user.read']);
  protectedResourceMap.set(serviceRoutesContainer.production.projectWebBaseUrl, [webUIResourceId + '/user_impersonation']);
  return protectedResourceMap;
}

